import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c(VIcon,{staticClass:"patient-info-gender",class:_vm.patient.gender && _vm.patient.gender.toLowerCase(),attrs:{"dense":""}},[_vm._v(" "+_vm._s(_vm.genderIcon)+" ")]),_vm._v(" DOB: "+_vm._s(_vm.dobUS)+" ("+_vm._s(_vm.patientAge)+") "+_vm._s(_vm.patientSSN)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }